import { useTranslation } from 'react-i18next';
import { ChevronUp } from 'lucide-react';
import { cn } from '@utils/cn';
import { PhoneSectionProps } from './types';

export const PhoneSection = ({
  title,
  badge,
  right,
  collapsed,
  onCollapsedChange,
  children,
}: PhoneSectionProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'scheduling.phone' });

  return (
    <section className="flex flex-col gap-2">
      <div className="flex min-h-8 items-center gap-2">
        <h3 className="whitespace-nowrap text-sm font-bold text-neutral-800">{title}</h3>
        {badge}
        <span className="flex-1" />
        {right}
        {onCollapsedChange && (
          <button
            type="button"
            aria-expanded={!collapsed}
            aria-label={t(collapsed ? 'expand' : 'collapse')}
            onClick={() => onCollapsedChange(!collapsed)}
            className="-mr-2 flex h-10 w-10 items-center justify-center text-neutral-500">
            <ChevronUp className={cn('h-4 w-4 transition-transform', collapsed && 'rotate-180')} />
          </button>
        )}
      </div>
      {children}
    </section>
  );
};
